import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ExportWarning {
  type: string;
  id: string;
  name?: string | null;
  reason: string;
}

@Component({
  selector: 'app-export-warnings-dialog',
  templateUrl: './export-warnings-dialog.component.html',
  styleUrls: ['./export-warnings-dialog.component.css']
})
export class ExportWarningsDialogComponent {
  message: string;
  warnings: ExportWarning[];

  constructor(@Inject(MAT_DIALOG_DATA) private data: any) {
    this.message = data?.message;
    this.warnings = data?.warnings ?? [];
  }
}
